export let noConversationsSelected = "AymJ";
export let oneConversationSelected = "YBM6Ed";
export let someConversationsSelected = "XzAH7";
export let oneConversationSelectedWithSize = "$bpgdc";
export let someConversationsSelectedWithSize = "U4xLUd";
export let oneItemSelectedWithSize = "LXzc3c";
export let someItemsSelectedWithSize = "gCLQk";
export default {noConversationsSelected,oneConversationSelected,someConversationsSelected,oneConversationSelectedWithSize,someConversationsSelectedWithSize,oneItemSelectedWithSize,someItemsSelectedWithSize};